import template from './component.tpl.html';
import AlGuestlistEditorComponentController from './controller';

/**
 * @ngdoc component
 * @name festzelt-os.modules.guestlists.component:al-guestlist-editor
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example
 <example module="festzelt-os.modules.guestlists">
 <file name="index.html">
 <al-guestlist-editor-page-limits guestlist="{}"></al-guestlist-editor-page-limits>
 </file>
 </example>
 *
 */
angular
    .module('festzelt-os.modules.media')
    .component('alGuestlistEditorPageLimits', {
        bindings: {
            guestlist: '<',
            availableFields: '<',
            onModelUpdate: '&',
            globalModel: '<',
            showContent: '<'
        },
        controller: AlGuestlistEditorComponentController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlist-editor/pages/limits/component.js